module.exports = __webpack_public_path__ + "img/child.83a0a754.png";